var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MultiselectTags',{attrs:{"multiple":false},on:{"input":_vm.update},model:{value:(_vm.newValue),callback:function ($$v) {_vm.newValue=$$v},expression:"newValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }